/*
 * File: beautifulDayMonsterApi.ts
 * Project: beaker
 * -----
 * Last Modified: 15 Mar 2022 11:16:03 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ApiMultipleResponse } from 'models/ApiModels';
import { Customer, GetCustomersParams } from 'models/Customer';
import { ReduxState } from 'redux/store';

const baseUrl = process.env.REACT_APP_BEAUTIFUL_DAY_MONSTER_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_BEAUTIFUL_DAY_MONSTER;

export const beautifulDayMonsterApi = createApi({
  reducerPath: 'beautifulDayMonsterApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as ReduxState).app.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('x-functions-key', functionsKey);
        headers.set('Content-Type', 'application/json');
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getCustomers: builder.query<ApiMultipleResponse<Customer>, Partial<GetCustomersParams>>({
      query: () => ({
        url: '/customers'
      })
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetCustomersQuery, useGetVersionQuery, useGetApiNameQuery } = beautifulDayMonsterApi;
